define([
	"csi/def",
	"csi/def/Action",
	"csi/def/ActionFactory",
	"csi/reflection",
	"csi/util",
	"csi/xml"
], function(def, Action, ActionFactory, reflection, util, xml) {

	return ActionFactory.declare("Manage", Action, {
		// String: composite relationship to manage (optional)
		compositeId: null,

		// String: class of node to create/delete (optional)
		compositeClass: null,

		// String: form to show when creating managed node (set to "" to disable form) (optional)
		idForm: null,

		constructor: function(obj) {
			// summary: read required members
			this.compositeId = util.getProperty(obj, "CompositeId");
			this.compositeClass = util.getProperty(obj, "CompositeClass");
			this.idForm = util.getProperty(obj, "Form", def.DEFAULT_FORM_ID);

			// set defaults for action if not explicitly configured
			this.m_typeControl = this.m_typeControl || def.ACTION_TOGGLE_BUTTON;
			this.m_tag = this.m_tag || "Manage";
			this.m_id = this.m_id || (this.m_tag + this.compositeId);
			this.setBaseRights(xml.RIGHT_WRITE);
		},

		isValid: function() {
			// summary: check for required members
			return this.compositeId && this.compositeClass && this.inherited(arguments);
		},

		_getNameParams: function(/*csi.LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action
			if (this.m_rcTarget) {
				return [lr.getTypeAttribute(this.m_rcTarget.getType(), this.compositeId)];
			}

			return null;
		},

		checkNodeAccess: function(/*Node*/node,  /*Context*/ctx) {
			// summary: make sure the user has appropriate rights to create/delete the managed node
			var child = ctx.cache.getChildNode(node, this.compositeId);
			if (child && !xml.nodeCanBeDeleted(child)) {
				return false;
			}

			// make sure class to create is not abstract and relationship is enabled
			if (!this.inherited(arguments)) {
				return false;
			}

			if (this.compositeClass) {
				const rc = reflection.getClass(this.compositeClass);
				if (!rc || rc.abstractOrDisabled) {
					return false;
				}
			}

			const rca = reflection.getAttribute(node, this.compositeId);
			if (rca?.isEditingDisabled) {
				return false;
			}

			return xml.nodeHasAccess(node, this.m_right) && xml.nodeHasRight(node, this.m_rightBase);
		},

		isToggledInitially: function(/*Context*/ctx) {
			// summary: determine if action should be in toggled state initially
			var node = ctx.getNode();
			if (!node) {
				return false;
			}

			var value = node[this.compositeId];
			return this.compositeId ? xml.isValidURL(value) : value;
		}
	});
});